module.exports = __webpack_public_path__ + "img/15.39e6af2d.jpg";